var map = {
	"./br.json": "./src/config/locales/br.json",
	"./de.json": "./src/config/locales/de.json",
	"./el.json": "./src/config/locales/el.json",
	"./en.json": "./src/config/locales/en.json",
	"./es.json": "./src/config/locales/es.json",
	"./it.json": "./src/config/locales/it.json",
	"./ko.json": "./src/config/locales/ko.json",
	"./ru.json": "./src/config/locales/ru.json",
	"./sl.json": "./src/config/locales/sl.json",
	"./tr.json": "./src/config/locales/tr.json",
	"./us.json": "./src/config/locales/us.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";